export default __webpack_public_path__ + "static/media/memnbre_smain.18e7d92b.JPG";